import React, { Component } from 'react';
import config from 'react-global-configuration';
import { Editor } from '@tinymce/tinymce-react';
// Importação do Router
import { BrowserRouter, Route, Switch, Link, Redirect} from 'react-router-dom';
// Importação do Bootstrap
import { Button, Modal, Grid, Row, Col, Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Loading from '../Miscelania/Loading';
import Overlay from '../Miscelania/Overlay';
// Helpers de formulário
import Topo from '../Layout/Topo';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import RequestApi from '../Miscelania/RequestApi';


class ConfiguracoesEdit extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      qtd_questions: '',
      hour_value: '',
      exam_description: 0,
    };
    //bind geral
    //Handlers
    this.handleEditorChange = this.handleEditorChange.bind(this);
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.editarConfiguracoes = this.editarConfiguracoes.bind(this);
  }


  // Handlers de form
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleEditorChange(e) {
    var exam_description = e.target.getContent();
    this.setState({exam_description: exam_description});
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  loadData(e) {
    var url = config.get('api') + '/configuracoes';
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/categorias');
        if (responseJson.status === 'success') {
          self.setState({exam_description: responseJson.data.exam_description});
          self.setState({qtd_questions: responseJson.data.qtd_questions});
          self.setState({hour_value: responseJson.data.hour_value});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }

  editarConfiguracoes(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var dados_salvar = {
      qtd_questions: this.state.qtd_questions,
      exam_description: this.state.exam_description,
      hour_value: this.state.hour_value,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/configuracoes', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }



  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title"><i className="fa fa-fw fa-cog"></i> Configurações Gerais</h3>
      <hr/>
      <form onSubmit={this.editarConfiguracoes}>
        <div className="form-group">
          <label>Quantidade de opções de múltipla escolha:</label>
          <input type="text" name="qtd_questions" className="form-control" value={this.state.qtd_questions} onChange={this.handleChange.bind(this, 'qtd_questions')} />
        </div>
        <div className="form-group">
          <label>Descrição na prova:</label>
          {(this.state.exam_description !== 0 && typeof this.state.exam_description != 'undefined') ? (
            <Editor
              initialValue={this.state.exam_description}
              init={{
                plugins: 'link image code',
                toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code',
                language_url: config.get('cdn') + '/js/pt_BR.js',
                height: '300px',
              }}
              onChange={this.handleEditorChange}
            />
            ): ""}
        </div>
        <div className="form-group">
          <button className="btn btn-primary btn-block btn-inline" type="submit"><i className="fa fa-fw fa-save"></i> Salvar Configurações</button>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default ConfiguracoesEdit;



// WEBPACK FOOTER //
// ./src/Components/Configuracoes/ConfiguracoesEdit.js